import IconHOC from '../IconHOC';

import { ReactComponent as EditIcon } from './edit.svg';

export const Edit = IconHOC(EditIcon);
